import React, { useEffect,useRef } from 'react';
import "./index.css";
import "./mobile.css";
import Button from "../button/index.js"
import { useState } from 'react';

function GetInput({ indexNumber, left, top, imageSource, heading,closeFunction,moveFunction,upFunction,downFunction,zIndex }) {
    const [userEmail,SetUserEmail] = useState(null);
    const [uploadState,SetUploadState] = useState({isValid:null,message:null});
    const [uploading,SetUploading] = useState(false);

    const uploadNewEmail = () => {
        SetUploading(true);
        SetUploadState({isValid: true, message: "Hold on uploading your details",color:"black"});
        fetch('https://larus-c6a6bad528e1.herokuapp.com/signUpForNewsletter', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: userEmail }),
          })
        .then(response => {
          // Check for response.ok here to handle HTTP errors
          return response.text().then(text => {
            // Now we have the text, and we know the response was ok
            if(response.ok){
                SetUploadState({isValid: true, message: text,color:"green"});
            }
            else{
                SetUploadState({isValid: false, message: text,color:"red"});
            }
            SetUploading(false);
          });
        })
        .catch((error) => {
          // Handle any errors that occurred during fetch or response processing
          console.error('Error:', error);
        });
    }
    const uploadCounterRef = useRef(null); // Use useRef to keep the interval ID across renders
    useEffect(() => {
        console.log(uploading);
        if(uploading){
            let i = 1;
            uploadCounterRef.current = window.setInterval(function(){
               let message =  "Hold on uploading your details";
               for(let t=0;t<i;t++){
                message+="."
               }
               SetUploadState({isValid: true, message: message,color:"black"});
               i++
               if(i>3){
                i=1
               }
            },500)
        }
        else {
            if (uploadCounterRef.current) {
                window.clearInterval(uploadCounterRef.current);
                uploadCounterRef.current = null; // Clear the ref after clearing the interval
            }
        }

        // Cleanup function to clear the interval if the component unmounts
        return () => {
            if (uploadCounterRef.current) {
                window.clearInterval(uploadCounterRef.current);
            }
        };
      }, [uploading]);

    const updateEmail = (e) => {
        SetUserEmail(e.target.value);
    }

    return (
        <div className="dialog-box" id={indexNumber} 
        style={{ left: left, 
            top: top, 
            zIndex:zIndex
        }}
        onMouseMove={moveFunction}
        onMouseUp={upFunction}
        data-boxindex={indexNumber}
        >
            <div className="dialog-box-heading big-text draggable-box"
             onMouseDown={downFunction}
             data-boxindex={indexNumber}
            >
                <div className="dialog-box-info draggable-box" data-boxindex={indexNumber}>
                    <img className="heading-image draggable-box" src={imageSource} alt="heading" data-boxindex={indexNumber}/>
                    <div className='draggable-box' data-boxindex={indexNumber}>{heading}</div>
                </div>
                <img className="close-button" src="./images/UI/close.png" alt="close button" onClick={()=>{closeFunction(indexNumber)}} />
            </div>
            <div className="dialog-box-body small-text"> 
            Sign up to our mailing list, and we promise, at least once we will make you laugh.
            <input style={{display: uploadState.isValid ? "none" : "block"}} className='newsletter-input' type='email' placeholder='Pop your email in here, you know you want to!' onChange={updateEmail}></input>
            <div className='error-message' style={{color: uploadState.color}}>{uploadState.message}</div>
            <div style={{display: uploadState.isValid ? "none" : "block"}}><Button text="Submit" functionToAdd={uploadNewEmail}></Button></div>
            </div>
        </div>
    );
}

export default GetInput;
